/**
 * Sizes ornament separators to the preceding title block width and centers the icon on the title.
 */
(() => {
  const DESKTOP_MQ = window.matchMedia('(min-width: 750px)');
  let frame = 0;

  /** @param {Element | null | undefined} node */
  function findTextBlock(node) {
    if (!(node instanceof Element)) return null;
    if (node.matches('.text-block')) return node;
    return node.querySelector('.text-block');
  }

  /** @param {Element} separator */
  function findTitleContext(separator) {
    const wrapper = separator.closest('.section-content-wrapper');
    if (!wrapper) return null;

    const separatorBlock = separator.closest('.shopify-block');
    let node = separatorBlock ? separatorBlock.previousElementSibling : separator.previousElementSibling;

    while (node) {
      const textBlock = findTextBlock(node);
      if (textBlock) {
        const measureTarget =
          textBlock.querySelector('h1, h2, h3, h4, h5, h6') || textBlock;
        return { measureTarget, wrapper };
      }
      node = node.previousElementSibling;
    }

    return null;
  }

  /** @param {Element} separator */
  function shouldMatch(separator) {
    return DESKTOP_MQ.matches
      ? separator.dataset.matchTitleDesktop === 'true'
      : separator.dataset.matchTitleMobile === 'true';
  }

  /** @param {Element} separator */
  function syncOne(separator) {
    const active = shouldMatch(separator);
    separator.classList.toggle('ornament-separator--match-title-active', active);

    if (!active) {
      separator.style.removeProperty('--ornament-title-offset-active');
      separator.style.removeProperty('--ornament-title-width-active');
      return;
    }

    const context = findTitleContext(separator);
    if (!context) return;

    const wrapperRect = context.wrapper.getBoundingClientRect();
    const titleRect = context.measureTarget.getBoundingClientRect();

    separator.style.setProperty(
      '--ornament-title-offset-active',
      `${titleRect.left - wrapperRect.left}px`
    );
    separator.style.setProperty('--ornament-title-width-active', `${titleRect.width}px`);
  }

  function syncAll() {
    document.querySelectorAll('.ornament-separator').forEach((separator) => {
      if (separator.dataset.matchTitleDesktop === 'true' || separator.dataset.matchTitleMobile === 'true') {
        syncOne(separator);
      }
    });
  }

  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(syncAll);
  }

  function scheduleSoon() {
    schedule();
    window.setTimeout(schedule, 50);
    window.setTimeout(schedule, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSoon, { once: true });
  } else {
    scheduleSoon();
  }

  window.addEventListener('resize', schedule, { passive: true });
  DESKTOP_MQ.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', scheduleSoon);
  document.addEventListener('shopify:section:reorder', scheduleSoon);
  document.addEventListener('shopify:block:select', schedule);

  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(schedule);

    function observeTargets() {
      document.querySelectorAll('.ornament-separator').forEach((separator) => {
        const context = findTitleContext(separator);
        if (!context) return;
        observer.observe(context.measureTarget);
        observer.observe(context.wrapper);
      });
    }

    observeTargets();
    document.addEventListener('shopify:section:load', observeTargets);
  }

  if (document.fonts?.ready) {
    document.fonts.ready.then(scheduleSoon);
  }
})();
